module.exports = __webpack_public_path__ + "static/media/WizardsPoster02.ebb369e7.png";